$(document).on('submit', '.search-form', function (e) {
    e.preventDefault();
    // var searchInput = $('#searchBar').val();
    var searchInput = $(this).find("input[name=query]").val();
    var url = "/search/" + searchInput;
    // console.log(url);
    window.location.href = url;
});

addEventListener('DOMContentLoaded', _ => {
    const searchBtn = $('#search');
    const searchMenu = $('.header-search');
    const searchBar = $('.header-search #headerSearchBar');
    searchBtn.on('click', () => {
        if (!document.querySelector('div.modal-backdrop')) {
            const backdrop = document.createElement('div');
            backdrop.classList.add('modal-backdrop');
            backdrop.id = "search-modal-backdrop";
            backdrop.classList.add('show-backdrop');

            backdrop.addEventListener('click', () => {
                backdrop.classList.toggle('show-backdrop');
                searchMenu.toggleClass('show');
            })

            document.body.append(backdrop);
        } else {
            const backdrop = document.querySelector('#search-modal-backdrop');
            backdrop.classList.toggle('show-backdrop');
        }
        searchMenu.toggleClass('show');
        searchBar.trigger('focus');
    })

    const cancelSearch = $('#cancel-search');
    cancelSearch.on('click', () => {
        const backdrop = document.querySelector('#search-modal-backdrop');
        backdrop.classList.toggle('show-backdrop');
        searchMenu.toggleClass('show');
    })

    const topicFilter = document.querySelectorAll('.topic-select');
    const selectedSort = document.querySelector('#sort_by option:checked');
    topicFilter.forEach(elem => {
        elem.addEventListener('change', (ev) => {
            let searchInput = document.querySelector("input[name=query]#headerSearchBar").value;
            window.location.href = `/search${searchInput ? '/'+searchInput : ''}?category=${ev.target.value}${selectedSort.value ? '&sortBy='+selectedSort.value : ''}`;
        })
    })

    const sortOrder = document.querySelectorAll('.sort-order-select');
    const selectedTopic = document.querySelector('#topic option:checked');
    sortOrder.forEach(elem => {
        elem.addEventListener('change', (ev) => {
            let searchInput = document.querySelector("input[name=query]#headerSearchBar").value;
            window.location.href = `/search${searchInput ? '/'+searchInput : ''}?category=${selectedTopic.value}${ev.target.value ? '&sortBy='+ev.target.value : ''}`;
        })
    })
});